import { stageLabel } from "@staffsmith/api-types/labels";
import type { ReactNode } from "react";
import { ApiError } from "./api.js";

// The few building blocks the portal's pages share: plain HTML elements, styled
// in styles.css.

export function ErrorNote({ error }: { error: unknown }) {
  if (!error) return null;
  if (error instanceof ApiError) {
    return (
      <div className="error" role="alert">
        <strong>{error.title}</strong>
        {error.detail ? <span> {error.detail}</span> : null}
        {error.errors.length ? (
          <ul>
            {error.errors.map((e) => (
              <li key={`${e.field}:${e.message}`}>
                {e.field}: {e.message}
              </li>
            ))}
          </ul>
        ) : null}
        {error.requestId ? <small> Request {error.requestId}</small> : null}
      </div>
    );
  }
  return (
    <div className="error" role="alert">
      {error instanceof Error ? error.message : String(error)}
    </div>
  );
}

export const Loading = () => <p className="muted">Loading…</p>;

export function Empty({ children }: { children: ReactNode }) {
  return <p className="muted">{children}</p>;
}

export const label = (value: string) => value.replaceAll("_", " ");

export function Badge({ value }: { value: string }) {
  return <span className={`badge badge-${value}`}>{label(value)}</span>;
}

// A submission stage as people read it ("interviewing", not "interview"; design v0.6, C2).
export function StageBadge({ stage }: { stage: string | null | undefined }) {
  return <span className={`badge badge-${stage ?? ""}`}>{stageLabel(stage)}</span>;
}

export const formatDate = (iso: string | null | undefined) =>
  iso
    ? new Date(`${iso.slice(0, 10)}T00:00:00Z`).toLocaleDateString(undefined, {
        dateStyle: "medium",
        timeZone: "UTC",
      })
    : "—";
